import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { UiModule } from '../ui';
import { SharedUiModule } from '../../shared/ui';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { RevisionService } from './revision.service';
import { RevisionsResolver } from './revisions.resolver';
import { RevisionResolver } from './revision.resolver';
import { RevisionListComponent } from './revision-list.component';

@NgModule({
  imports: [
    BrowserModule,
    SharedUiModule,
    UiModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    RevisionListComponent
  ],
  providers: [
    RevisionService,
    RevisionsResolver,
    RevisionResolver
  ],
})
export class RevisionModule { }
